import type { ReactNode } from 'react';
import { useAuth } from './useAuth';
import LoginPage from '../components/LoginPage';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Route guard that renders LoginPage inline when unauthenticated.
 *
 * Does NOT use Navigate/redirect to avoid loops with MSAL popup flow.
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <p style={{ textAlign: 'center', marginTop: '2rem' }}>Loading...</p>;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
